import { handleActions } from "redux-actions";
import {
    getShortUrlSuccess,
    mergeAppState,
    mergeShortUrl,
    setSidParams,
    setAuthPolicy
} from "./actions";

const initialState = {
    isLoading: false,
    user: null,
    authPolicyCodes: [],
    authPolicyDefinitions: {},
    sidParams: {},
    shortUrl: {
        id: "",
        body: "",
    }
};

export const appReducer = handleActions(
    {
        [setSidParams]: (state, { payload }) => ({
            ...state,
            ...payload
        }),
        [mergeAppState]: (state, { payload }) => ({
            ...state,
            ...payload
        }),
        [setAuthPolicy]: (state, { payload }) => ({
            ...state,
            ...payload,
            isLoading: false
        }),
        [mergeShortUrl]: (state, { payload }) => ({
            ...state,
            shortUrl: {
                ...state.shortUrl,
                ...payload
            }
        }),
        [getShortUrlSuccess]: (state, { payload }) => ({
            ...state,
            shortUrl: {
                ...initialState.shortUrl,
                ...payload
            }
        }),
    },
    initialState
);
